import React, { useEffect, useState } from 'react';
import { Button, Checkbox, Icon } from 'react-materialize';
import { Container, DivDetalhe, Labels, Linha } from './styled';
import api from '../../../services/api';
import { alerta, haveData } from '../../../services/funcoes';
import DirectTituloJanela from '../../../Components/Globals/DirectTituloJanela';
import Header from '../../../Components/System/Header';
import SelectQuery from '../../../Components/Globals/SelectQuery';
import { getFromStorage } from '../../../services/auth';
import { IoMdSave } from 'react-icons/io';
import { useHistory } from 'react-router-dom';

export default function AddSearchsNotApplied() {
  const [loading, setLoading] = useState(false);
  const [renderer, setRenderer] = useState(false);
  const [customers, setCustomers] = useState([]);
  const [searchs, setSearchs] = useState([]);

  const history = useHistory();
  const client = history?.location?.state?.client;
  const editSearchs = history?.location?.state?.searchs;

  const [customerSelect, setCustomerSelect] = useState(client || null);
  const [searchsNotApplied, setSearchsNotApplied] = useState(editSearchs || []);

  async function handleFilterCustomers(text) {
    try {
      setLoading(true);
      const sessao = getFromStorage();

      let url = `v1/schedule/clientes/${sessao.empresaId}/${sessao.codigoUsuario}`;
      const dataToSend = {
        filtro: String(text),
      };

      const retorno = await api.post(url, dataToSend);
      const { sucess, data } = retorno.data;

      if (sucess && data) {
        setCustomers(data);
      }
    } catch (err) {
      alerta('Erro ao carregar os clientes =>' + err, 2);
    } finally {
      setLoading(false);
    }
  }

  function onChangeSearchSelect(event, item) {
    const response = event.target.checked;
    if (response) {
      item.GPC_FLG_STATUS = 1;
      item.GAP_FLG_ESPECIFICA_LABEL = 1;
      setSearchsNotApplied([...searchsNotApplied, item]);
    } else {
      item.GPC_FLG_STATUS = 0;
      item.GAP_FLG_ESPECIFICA_LABEL = 0;
      setSearchsNotApplied(searchsNotApplied.filter((e) => Number(e.GAP_ID) !== Number(item.GAP_ID)));
    }
  }

  function onChangeSelectSpecific(value, item) {
    const pos = searchsNotApplied.findIndex((e) => e.GAP_ID === item.GAP_ID);
    if (pos !== -1) {
      searchsNotApplied[pos].GPC_FLG_STATUS = value;
      searchsNotApplied[pos].GAP_FLG_ESPECIFICA_LABEL = value;
    }
    setSearchsNotApplied(searchsNotApplied);
    setRenderer(!renderer);
  }

  async function getData() {
    try {
      setLoading(true);
      const sessao = getFromStorage();
      const res = await api.get(`v1/searchs/${sessao.empresaId}/${sessao.codigoUsuario}`);

      const { data } = res.data;

      if (haveData(data)) {
        setSearchs(data);
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  }

  async function handleAddSearchNotApplied() {
    try {
      setLoading(true);
      const sessao = getFromStorage();

      const parseSearchs = searchsNotApplied.map((item) => {
        const ele = searchs.find((e) => e.GAP_ID === Number(item.GAP_ID));
        ele.GPC_FLG_STATUS = 0;

        if (
          (item.GAP_FLG_ESPECIFICA_LABEL && item.GAP_FLG_ESPECIFICA_LABEL.value === 1) ||
          (item.GAP_FLG_ESPECIFICA === 1 && item.GAP_FLG_ESPECIFICA_LABEL === 1)
        ) {
          ele.GPC_FLG_STATUS = 1;
        }
        return ele;
      });

      const payload = {
        GPC_CLI_ID: Number(customerSelect.CLI_ID) || Number(customerSelect.GPC_CLI_ID),
        CLI_CODIGO: Number(customerSelect.CLI_CODIGO),
        CLI_RAZAO_SOCIAL: customerSelect.CLI_RAZAO_SOCIAL,
        CLI_NOME_FANTASIA: customerSelect.CLI_NOME_FANTASIA,
        PESQUISAS: parseSearchs.filter((item) => item !== null),
      };

      const res = await api.post(`v1/searchs/notaplied/customer/${sessao.empresaId}/${sessao.codigoUsuario}`, payload);

      const { sucess } = res.data;

      if (sucess) {
        alerta('Salvo com sucesso', 1);
        history.push('/searchs/notaplied');
      }
    } catch (error) {
      alerta('Erro ao salvar');
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    if (customerSelect && searchs && searchs.length === 0) {
      getData();
    }
    // eslint-disable-next-line
  }, [customerSelect]);

  return (
    <>
      <div
        style={{
          display: loading !== false ? 'block' : 'none',
          position: 'absolute',
          height: '100vh',
          width: '100vw',
          top: '0px',
          left: '0px',
          backgroundColor: '#00000069',
          zIndex: '50',
        }}
        id="loading"
      />
      <Header />
      <Container>
        <DirectTituloJanela
          urlVoltar={'/searchs/notaplied'}
          titulo={
            loading ? (
              'Aguarde...'
            ) : (
              <span style={{ display: 'flex', alignItems: 'center' }}>
                <Icon>event_note</Icon>
                Adicionar pesquisa não se aplica
              </span>
            )
          }
        />
        {client && (
          <div style={{ display: 'flex', flexDirection: 'column', marginTop: '0.5rem', marginLeft: '1rem' }}>
            <span style={{ fontWeight: '700', marginBottom: '0.5rem', fontSize: '1.4rem', color: '#8e44ad' }}>
              {client.CLI_NOME_FANTASIA}
            </span>
          </div>
        )}
        {!client && (
          <Linha style={{ alignItems: 'center', margin: '0.5rem 0' }}>
            <DivDetalhe style={{ width: '100%' }}>
              <Labels>Cliente</Labels>
              <SelectQuery
                onChangeComponentIsExternal
                loading={false}
                colorPrimary
                query={customers}
                keys={['CLI_ID', 'CLI_NOME_FANTASIA', 'CLI_CODIGO', 'CLI_RAZAO_SOCIAL']}
                label="CLI_NOME_FANTASIA"
                onChange={async (text) => {
                  await handleFilterCustomers(isNaN(text) ? text?.toUpperCase() : Number(text));
                }}
                onSelect={(item) => {
                  setCustomerSelect(item);
                }}
                onDelete={() => {
                  setCustomerSelect(null);
                }}
              />
            </DivDetalhe>
          </Linha>
        )}

        {customerSelect && (
          <div style={{ display: 'flex', flexDirection: 'column', marginBottom: '0.5rem', marginLeft: '1rem' }}>
            <span style={{ fontWeight: '600', marginBottom: '0.5rem', fontSize: '1.2rem' }}>
              Selecione as pesquisas que não deseja aplicar na pesquisa desse cliente
            </span>

            <span style={{ fontWeight: '600', marginBottom: '0.5rem', fontSize: '1.2rem', color: '#8e44ad' }}>
              Pesquisas específicas
            </span>
            {searchs
              ?.filter((e) => e.GAP_FLG_ESPECIFICA === 1)
              ?.map((item) => (
                <div key={item.GAP_ID} style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                  <Checkbox
                    id={item.GAP_ID}
                    label={item.GAP_DESCRICAO}
                    value={item.GAP_ID}
                    checked={searchsNotApplied.some((e) => Number(e.GAP_ID) === Number(item.GAP_ID))}
                    onChange={(event) => onChangeSearchSelect(event, item)}
                  />
                  <span style={{ fontSize: '0.7rem', fontWeight: '500', color: '#9e9e9e' }}>
                    ({`${item.GAP_DESCRICAO_LONGA.toUpperCase()}`})
                  </span>
                  {searchsNotApplied.some((e) => Number(e.GAP_ID) === Number(item.GAP_ID)) &&
                  item.GAP_FLG_ESPECIFICA ? (
                    <div style={{ width: '160px' }}>
                      <SelectQuery
                        inputName="selectSpecific"
                        loading={false}
                        itemSelected={
                          searchsNotApplied.find((e) => Number(e.GAP_ID) === Number(item.GAP_ID))
                            ?.GAP_FLG_ESPECIFICA_LABEL
                        }
                        colorPrimary
                        query={[
                          { label: 'Ativado', value: 1 },
                          { label: 'Desativado', value: 2 },
                        ]}
                        keys={['label', 'value']}
                        label="label"
                        onSelect={(e) => onChangeSelectSpecific(e, item)}
                        onDelete={() => onChangeSelectSpecific(0, item)}
                      />
                    </div>
                  ) : (
                    searchsNotApplied.some((e) => Number(e.GAP_ID) === Number(item.GAP_ID)) && (
                      <span style={{ fontSize: '0.7rem', fontWeight: '500', color: '#000' }}>Desativado</span>
                    )
                  )}
                </div>
              ))}
            <span style={{ fontWeight: '600', marginTop: '0.5rem', fontSize: '1.2rem', color: '#8e44ad' }}>
              Outras pesquisas
            </span>
            {searchs?.filter((e) => e.GAP_FLG_ESPECIFICA !== 1)?.map((item) => (
              <div key={item.GAP_ID} style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                <Checkbox
                  id={item.GAP_ID}
                  label={item.GAP_DESCRICAO}
                  value={item.GAP_ID}
                  checked={searchsNotApplied.some((e) => Number(e.GAP_ID) === Number(item.GAP_ID))}
                  onChange={(event) => onChangeSearchSelect(event, item)}
                />
                <span style={{ fontSize: '0.7rem', fontWeight: '500', color: '#9e9e9e' }}>
                  ({`${item.GAP_DESCRICAO_LONGA.toUpperCase()}`})
                </span>
                {searchsNotApplied.some((e) => Number(e.GAP_ID) === Number(item.GAP_ID)) && item.GAP_FLG_ESPECIFICA ? (
                  <div style={{ width: '160px' }}>
                    <SelectQuery
                      inputName="selectSpecific"
                      loading={false}
                      itemSelected={
                        searchsNotApplied.find((e) => Number(e.GAP_ID) === Number(item.GAP_ID))
                          ?.GAP_FLG_ESPECIFICA_LABEL
                      }
                      colorPrimary
                      query={[
                        { label: 'Ativado', value: 1 },
                        { label: 'Desativado', value: 2 },
                      ]}
                      keys={['label', 'value']}
                      label="label"
                      onSelect={(e) => onChangeSelectSpecific(e, item)}
                      onDelete={() => onChangeSelectSpecific(0, item)}
                    />
                  </div>
                ) : (
                  searchsNotApplied.some((e) => Number(e.GAP_ID) === Number(item.GAP_ID)) && (
                    <span style={{ fontSize: '0.7rem', fontWeight: '500', color: '#000' }}>Desativado</span>
                  )
                )}
              </div>
            ))}
          </div>
        )}

        <Linha style={{ alignItems: 'center', justifyContent: 'flex-end' }}>
          <Button
            disabled={!customerSelect}
            onClick={handleAddSearchNotApplied}
            className="waves-effect waves-light saib-button is-primary"
          >
            <IoMdSave size={20} />
            Salvar
          </Button>
        </Linha>
      </Container>
    </>
  );
}
